/**
 * NOTE: key names are same as key names in translation file.
 * This is to allow for easy mapping.
 */

export const userGroups = {
  dentist: 'Dentist',
  dealer_technician: 'Dealer Technician',
  scican_employee: 'SciCan Customer Service',
}

export const groups = {
  dentist: 'customer',
  dealer_technician: 'tech',
  scican_technician: 'tech',
  sales: 'salesrep',
  administrator: 'adm',
  embedded_software_group: 'adm',
  it: 'adm',
  business_unit: 'tech',
}
/**
 * NOTE: key names are same as key names in translation file.
 * This is to allow for easy mapping.
 */

export const userSubGroups = [
  'scican_technician',
  'scican_customer_service',
  'embedded_software_group',
  // "administrator",
  // "it",
  'sales',
  'business_unit',
  'marketing',
]

export const getAvailableGroup = (accessLevel) => {
  switch (accessLevel) {
    case 'protected':
      return 'Coltene and Dealer Tech Users'
    case 'private':
      return 'Coltene Users'
    case 'admin':
      return 'Admin Users'
    default:
      return 'everyone'
  }
}
